import type { LegalDocumentId } from '@/config/legal-documents';

export {
  LEGAL_DOCUMENT_IDS,
  legalDocumentPath,
  SIGNUP_LEGAL_DOCUMENT_PATHS,
  type LegalDocumentId,
} from '@/config/legal-documents';

/**
 * The query params the legacy signup app answered with a legal document, in
 * the order it checked them. Other apps, landing pages and old iOS builds
 * link to these on the signup domain, so the entry keeps answering them.
 */
const LEGAL_DOCUMENT_PARAMS: readonly (readonly [string, LegalDocumentId])[] = [
  ['terms_of_use', 'terms-of-use'],
  ['privacy_policy', 'privacy-policy'],
  ['notice_of_privacy_practices', 'notice-of-privacy-practices'],
  ['tcpa_authorization', 'tcpa-authorization'],
  ['ai_notice', 'ai-notice'],
  ['consumer_health_data_privacy_notice', 'consumer-health-data-privacy-notice'],
];

/**
 * The legal document a query string asks for, or null. As in the legacy app,
 * a param counts when present unless its value is exactly `false`, and the
 * first match in check order wins.
 */
export function legalDocumentFromParams(params: URLSearchParams): LegalDocumentId | null {
  for (const [param, id] of LEGAL_DOCUMENT_PARAMS) {
    if (params.has(param) && params.get(param) !== 'false') return id;
  }
  return null;
}
